<template>
  <footer class="m-grid__item m-footer ">
    <div class="m-container m-container--fluid m-container--full-height m-page__container">
      <div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
        <div
          class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last d-print-none"
        >
          <span class="m-footer__copyright">
            <img
              alt="Griffin"
              src="@/assets/media/img/logo/tag_griffin.svg"
              height="20"
              style="margin:6px 5px 10px 0;"
            />
            Griffin Gestor Financeiro NW &copy; 2025
          </span>
        </div>
        <div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
          <ul class="m-footer__nav m-nav m-nav--inline m--pull-right">
            <li class="m-nav__item">
              <a href="https://gruponewway.com.br/" class="m-nav__link">
                <img
                  src="@/assets/media/img/logo/logo_newway.svg"
                  height="20"
                  style="margin:6px 5px 10px 0;"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style></style>
